import { allowMarketTab } from "../config/featureVisibility";

const ROOT_TAB_VALUES = new Set(["feed", "map", "groups", "market"]);
const GROUPS_VIEW_VALUES = new Set(["list", "create", "detail", "home"]);

function normalizeSearchString(search) {
  if (!search) return "";
  return search.startsWith("?") ? search : `?${search}`;
}

export function normalizeRootTab(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (!ROOT_TAB_VALUES.has(normalized)) {
    return "feed";
  }
  if (normalized === "market" && !allowMarketTab) {
    return "feed";
  }
  return normalized;
}

export function getRootTabFromSearch(search) {
  const params = new URLSearchParams(normalizeSearchString(search));
  return normalizeRootTab(params.get("tab"));
}

export function buildRootTabSearch(search, tab) {
  const params = new URLSearchParams(normalizeSearchString(search));
  const nextTab = normalizeRootTab(tab);

  if (nextTab === "feed") {
    params.delete("tab");
  } else {
    params.set("tab", nextTab);
  }

  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
}

export function normalizeChatUserId(value) {
  const normalized = String(value || "").trim();
  return normalized || "";
}

export function getChatUserIdFromSearch(search) {
  const params = new URLSearchParams(normalizeSearchString(search));
  return normalizeChatUserId(params.get("chat"));
}

export function buildMessagesSearch(search, chatUserId) {
  const params = new URLSearchParams(normalizeSearchString(search));
  const normalizedChatUserId = normalizeChatUserId(chatUserId);

  if (normalizedChatUserId) {
    params.set("chat", normalizedChatUserId);
  } else {
    params.delete("chat");
  }

  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
}

export function normalizeGroupsView(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return GROUPS_VIEW_VALUES.has(normalized) ? normalized : "list";
}

export function normalizeGroupId(value) {
  const normalized = String(value || "").trim();
  return normalized || "";
}

export function getGroupsStateFromSearch(search) {
  const params = new URLSearchParams(normalizeSearchString(search));
  const view = normalizeGroupsView(params.get("groupsView"));
  const groupId = normalizeGroupId(params.get("group"));

  if ((view === "detail" || view === "home") && !groupId) {
    return { view: "list", groupId: "" };
  }

  if (view === "create") {
    return { view, groupId: "" };
  }

  return { view, groupId };
}

export function buildGroupsSearch(search, nextState) {
  const params = new URLSearchParams(normalizeSearchString(search));
  const nextView = normalizeGroupsView(nextState?.view);
  const nextGroupId = normalizeGroupId(nextState?.groupId);

  if (nextView === "list") {
    params.delete("groupsView");
    params.delete("group");
  } else if (nextView === "create") {
    params.set("groupsView", "create");
    params.delete("group");
  } else if (nextGroupId) {
    params.set("groupsView", nextView);
    params.set("group", nextGroupId);
  } else {
    params.delete("groupsView");
    params.delete("group");
  }

  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
}
